/*
 * @Author: bbqin
 * @Date: 2022-01-11 14:45:03
 * @LastEditTime: 2023-07-11 15:54:25
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\SmartCard\output.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import * as API from "./compatible";
import SmartCard from "./index";
import Message from './components/message';
import Portal from './components/portal';

/**
 * @param {string} mainCode 
 * @param {object} config 
 */

export default function compatible() {
    this.register("smartCard");
    return {
        store: SmartCard.useSmartCard,
        ...apiBindPage.call(this, API),
    };
}

const noPortalAPI = ['init', 'createSmartCard', 'getSmartCardData', 'initSmartCard'];

function apiBindPage(API) {
    let res = {};
    for (let pop of Object.keys(API)) {
        if (pop === 'initSmartCard') {
            res[pop] = (...params) => {
                const hasPortalSign = Portal.hasPortalSign();
                let result = {};

                // iframe外初始化组件属性
                if (hasPortalSign) {
                    const globalAPI = Portal.getGlobal();
                    if (globalAPI.length) {
                        // 调用getSmartCard获取数据
                        globalAPI.forEach(smartCard => {
                            const { pageScope, id } = smartCard || {};
                            if (!pageScope) {
                                console.log('没有找到对应的pageScope');
                            } else {
                                const api = (pageScope?.smartCard || {})['getSmartCardData'];
                                if (api) {
                                    result = api(id);
                                }
                            }
                        });

                    }
                }

                params[1] = Object.assign({}, params[1], result);

                return API[pop].call(this, ...params);
            };
        } else if (!noPortalAPI.includes(pop)) {
            res[pop] = (...params) => {
                // iframe外的调用iframe内的smartCard的API
                if (params[0] === '_iframe') {
                    const globalAPI = Portal.getGlobal();
                    // 有API，需要传送数据
                    if (globalAPI.length) {
                        const result = [];
                        const name = pop;

                        // 不需要更新当前
                        // API[pop].call(this, ...params);

                        // 更新API
                        globalAPI.forEach(smartCard => {
                            const { pageScope, id } = smartCard || {};
                            if (!pageScope) {
                                console.log('没有找到对应的pageScope');
                            } else {
                                params[0] = id;
                                const api = (pageScope?.smartCard || {})[name];
                                if (api) {
                                    const res = api(...params);
                                    result.push(res);
                                }
                            }
                        });

                        return result[0];
                    }
                }

                // iframe内跨iframe调用外部的smartCard（portal）API
                const hasPortalSign = Portal.hasPortalSign();
                if (!hasPortalSign) {
                    const portal = Portal.getPortal();
                    // 有门，需要传送数据
                    if (portal.length) {
                        const result = [];
                        const name = pop;

                        // 更新当前
                        API[pop].call(this, ...params);

                        // 更新门
                        portal.forEach(smartCard => {
                            const { pageScope, id } = smartCard || {};
                            if (!pageScope) {
                                console.log('没有找到对应的pageScope');
                            } else {
                                params[0] = id;
                                const api = (pageScope?.smartCard || {})[name];
                                if (api) {
                                    const res = api(...params);
                                    result.push(res);
                                }
                            }
                        });

                        return result[0];
                    }
                }

                return API[pop].call(this, ...params);
            };
        } else {
            res[pop] = API[pop].bind(this);
        }
    }
    return res;
}

// 高亮功能的通信逻辑
const message = {
    publish: (message, topic = '') => {
        topic = topic || Message.getName('pagePortal');
        Message.publish(topic, message);
    },
    subscribe: (fn, topic = '', unique = false, newBind = false) => {
        topic = topic || Message.getName('pagePortal');
        Message.subscribe(topic, fn, unique, newBind);
    },
    unsubscribe: (fn, topic = '') => {
        topic = topic || Message.getName('pagePortal');
        Message.unsubscribe(topic, fn);
    },
};

compatible.init = API.init;
compatible.message = message;
compatible.component = SmartCard;
compatible.displayName = "SmartCard";
compatible.unfinished = [];